.page {
  position: absolute;
  inset: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: calc(var(--safe-t) + 8px) 24px calc(var(--safe-b) + 24px);
  background: radial-gradient(ellipse 120% 60% at 50% -10%, rgb(var(--accent-rgb) / 0.12), transparent 60%), var(--bg);
}

.topRow {
  display: flex;
  justify-content: flex-end;
  margin-right: -12px;
}

.brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 12px 0 28px;
}

.title {
  font-size: var(--fs-xl);
  font-weight: 800;
  letter-spacing: -0.02em;
  text-align: center;
}

.subtitle {
  margin-top: 6px;
  text-align: center;
  color: var(--text-2);
  font-size: var(--fs-sm);
  line-height: 1.5;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 24px;
}

.error {
  color: var(--danger);
  font-size: var(--fs-sm);
  font-weight: 600;
}

.success {
  margin-top: 24px;
  padding: 16px;
  border-radius: var(--r-md);
  background: var(--accent-soft);
  border: 1px solid rgb(var(--accent-rgb) / 0.3);
  line-height: 1.5;
  font-size: var(--fs-sm);
}

.link {
  align-self: center;
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 600;
}

.link:hover {
  color: var(--text);
}

.legal {
  font-size: var(--fs-xs);
  color: var(--text-3);
  text-align: center;
  line-height: 1.5;
}

.legal a {
  color: var(--text-2);
  text-decoration: underline;
}

.footer {
  margin-top: auto;
  padding-top: 28px;
  text-align: center;
  font-size: var(--fs-sm);
  color: var(--text-2);
}

.footer a {
  color: var(--accent);
  font-weight: 700;
}

.prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 4px 24px 24px;
}

.prompt h2 {
  font-size: var(--fs-lg);
  font-weight: 800;
  text-align: center;
}

.prompt form {
  width: 100%;
  margin-top: 4px;
}

.switcher {
  display: flex;
  padding: 4px;
  border-radius: var(--r-full);
  background: var(--surface-2);
  width: 100%;
}

.switcher button {
  flex: 1;
  height: 36px;
  border-radius: var(--r-full);
  font-weight: 700;
  font-size: var(--fs-sm);
  color: var(--text-2);
  transition: background var(--t-fast), color var(--t-fast);
}

.switcher button[aria-selected='true'] {
  background: var(--text);
  color: var(--bg);
}
